import { Pipe } from '@angular/core';
var IsNotEqualToPipe = (function () {
    function IsNotEqualToPipe() {
    }
    IsNotEqualToPipe.prototype.transform = function (input, other) {
        return input != other;
    };
    return IsNotEqualToPipe;
}());
export { IsNotEqualToPipe };
IsNotEqualToPipe.decorators = [
    { type: Pipe, args: [{ name: 'isNotEqualTo' },] },
];
/** @nocollapse */
IsNotEqualToPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=is-not-equal-to.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/boolean/is-not-equal-to.js
// module id = 227
// module chunks = 4